import { type LOCALE } from '../../i18n'

type ReplaceHyphen<T extends string> = T extends `${infer A}-${infer B}`
  ? ReplaceHyphen<`${A}_${B}`>
  : T

type LOCALE_UNDERSCORE = ReplaceHyphen<LOCALE>

export const recommendationAccessorGetUnderscoreLocale = (
  locale: LOCALE,
): LOCALE_UNDERSCORE => {
  return locale.replace('-', '_') as LOCALE_UNDERSCORE
}
